<script>
import { Line } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Line,
    data() {
        var dates = _.sortBy(_.values(_.mapValues(this.inspections, 'date')));
        var labels = _.map(dates, function(d) { return moment(d).format('D.M.YYYY'); });
        var series = _.uniq(_.flatten(_.map(_.values(_.mapValues(this.inspections, 'averages')), _.keys)));
        return {
            chartData: {
                labels: labels,
                datasets: _.map(series, (c) => {
                    var that = this;
                    return {
                        label: this.devcats[c].name,
                        data: _.map(dates, (k) => {
                            return _.keyBy(that.inspections, 'date')[k].averages[c]
                        }),
                        fill: false,
                        borderColor: this.devcats[c].graph_color,
                        backgroundColor: this.devcats[c].graph_color,
                        borderWidth: 1
                    };
                })
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: 1,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'right',
                    labels: {
                        font: {
                            size: 14,
                            fontColor: '#000'
                        }
                    }

                },
                spanGaps: true,
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        inspections: Array,
        devcats: Object
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
